import React, {useContext} from 'react';
import {productContext} from '../App';

const Search = ({filter}) => {
    const producs = useContext(productContext)
    const produc = producs[0]
    return (
        <select onClick={(e) => filter(e)}>
            <option value="All">All</option>
            <option value="Shirt">Shirt</option>
            <option value="Pants">Pants</option>
        </select>
    )
}

export default Search
